module.exports = __webpack_public_path__ + "media/svg/qa-8b7d90d4.svg";